

































































































































































import { Vue, Watch, Component } from "vue-property-decorator";
import testPass, { TestPassListParams } from "@/getinfo-api/test-pass";
import course, { CourseListParams } from "@/getinfo-api/course";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { TestPassList as ITestPassList } from "@/api/models/test-pass-list";
import { TestPass as ITestPass } from "@/api/models/test-pass";
import { CoursesList as ICourseList } from "@/api/models/courses-list";
import {
  getCurrentUserId,
  getCurrentCompanyId,
  isRoot,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import TestResultsTable from "@/views/tests/TestResultsTable.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ListenersListClass } from "@/classes/list/ListenersListClass";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import { CourseLectureShortList as ICourseLectureShortList } from "@/api/models/course-lecture-short-list";

@Component({
  components: {
    CSingleSelect,
    CustomButton,
    TestResultsTable,
    SelectEntity,
    CustomDatepicker,
    CustomTable
  }
})
export default class TestResults extends Vue {
  testCount: number | undefined = 0;
  limit: number = 30;
  offset: number = 0;
  testPassList: Array<ITestPass> = [];
  passedAtMin!: Date | undefined;
  passedAtMax!: Date | undefined;
  testType!: string | undefined;
  courseId!: string | undefined;
  courses!: ICourseList | undefined;
  showSpinner: boolean = false;
  listenerUserId!: string | undefined;
  lectureId!: string | undefined;
  lecturesList!: ICourseLectureShortList | undefined;
  listenersClassList!: ListenersListClass;
  coursesClassList!: CoursesListClass;

  data() {
    return {
      testType: undefined,
      passedAtMin: undefined,
      passedAtMax: undefined,
      courses: undefined,
      courseId: undefined,
      listenerUserId: undefined,
      lectureId: undefined,
      lecturesList: undefined,
      listenersClassList: undefined,
      coursesClassList: undefined
    };
  }

  @Watch("testType")
  updateTestType() {
    if (
      this.testType === "courseLecture" &&
      this.checkCompanyRoute &&
      this.courseId
    ) {
      this.getListLecturesByCourseId();
    }
  }

  @Watch("$route")
  updateRoute() {
    this.testType = this.checkCompanyRoute ? "course" : undefined;
    this.reload();
    this.getCoursesByRoute();
  }

  @Watch("courseId")
  updateListenersList() {
    if (this.courseId) {
      this.listenersClassList = new ListenersListClass(this.courseId);
    }

    if (this.testType === "courseLecture") {
      this.getListLecturesByCourseId();
    }
  }

  @Watch("selectedCompany")
  updateCompany() {
    this.courses = undefined;
    this.courseId = undefined;
    this.lectureId = undefined;
    this.listenerUserId = undefined;
    this.getCourses();
  }

  get userId() {
    return getCurrentUserId();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get checkCompanyRoute() {
    return this.$route.name === "testResultCompany";
  }

  get root() {
    return isRoot();
  }

  submitSettings() {
    this.testPassList = [];
    this.testCount = 0;
    this.offset = 0;
    this.getUserTestResult();
  }

  getListLecturesByCourseId() {
    if (this.courseId) {
      this.showSpinner = true;
      api.CourseLectureApi.listShort(this.courseId)
        .then((res: { data: ICourseLectureShortList }) => {
          this.lecturesList = res.data;
          this.lectureId = res.data?.lectures?.[0]?.id;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  get isCompanyOwner() {
    return currentUserIsCompanyOwner();
  }

  get accessToCourses() {
    let id: string | undefined;
    if (this.checkCompanyRoute) {
      id = this.root || this.isCompanyOwner ? undefined : this.userId;
    } else {
      id = undefined;
    }
    return id ? [id] : undefined;
  }

  getCourses() {
    this.showSpinner = true;
    let params: CourseListParams = {
      listenerUserIds: this.checkCompanyRoute ? undefined : [this.userId],
      companyIds: this.checkCompanyRoute ? [this.selectedCompany] : undefined,
      ownerIds: this.accessToCourses
    };
    this.coursesClassList = new CoursesListClass(params);
    this.showSpinner = false;
  }

  getUserTestResultByOffset() {
    this.offset += this.limit;
    this.getUserTestResult(this.offset);
  }

  get targetType() {
    if (this.checkCompanyRoute) {
      return this.testType;
    } else {
      if (this.testType === "course") {
        return this.testType;
      } else if (this.testType === "courseLecture") {
        return this.testType;
      } else return undefined;
    }
  }

  get targetId() {
    if (this.checkCompanyRoute) {
      if (this.testType === "course") {
        return this.courseId;
      } else if (this.testType === "courseLecture") {
        return this.lectureId;
      } else return undefined;
    } else {
      if (this.testType === "course") {
        return this.courseId;
      } else {
        return undefined;
      }
    }
  }

  get ownerId() {
    if (this.checkCompanyRoute) {
      return this.listenerUserId;
    } else return this.userId;
  }

  getUserTestResult(offset: number = 0) {
    this.showSpinner = true;
    let param: TestPassListParams = {
      targetType: this.targetType,
      targetId: this.targetId,
      passedAtMin: this.passedAtMin,
      passedAtMax: this.passedAtMax,
      ownerId: this.ownerId,
      limit: this.limit,
      offset: offset
    };
    testPass(param)
      .then((res: { data: ITestPassList }) => {
        this.testCount = res.data.count;
        if (res.data.tests) {
          res.data.tests.forEach(el => {
            this.testPassList.push(el);
          });
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  reload() {
    this.testCount = 0;
    this.limit = 30;
    this.offset = 0;
    this.testPassList = [];
    this.courseId = undefined;
    this.courses = undefined;
    this.listenerUserId = undefined;
    this.lectureId = undefined;
    this.lecturesList = undefined;
    this.passedAtMin = undefined;
    this.passedAtMax = undefined;
    this.getCoursesByRoute();
  }

  getCoursesByRoute() {
    if (!this.checkCompanyRoute) {
      this.getCourses();
      this.getUserTestResult();
    } else this.getCourses();
  }

  created() {
    this.testType = this.checkCompanyRoute ? "course" : undefined;
    this.getCoursesByRoute();
  }
}
